var _ellipse, _path, _rect, _path2, _path3, _path4, _path5, _path6, _polygon, _rect2, _rect3, _rect4, _path7, _rect5, _path8, _path9, _path10, _polygon2, _path11, _path12, _path13, _path14, _polygon3, _polygon4, _polygon5, _path15, _path16, _path17, _path18, _path19, _polygon6, _polygon7, _path20, _polygon8, _path21, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _circle, _rect22, _rect23, _rect24, _rect25, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookLover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#14 book lover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.67,
    cy: 256.99,
    rx: 130.29,
    ry: 18.73,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125,247.21s-2.39,3.4-5.88,2.76-5.3,2.45-2.47,4.16,11.83-.08,11.83-.08l1.12-5Z",
    fill: "#9b59b6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168.1,
    y: 53.69,
    width: 117.77,
    height: 203.31,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.29,95.28s-14.19,4.88-18.44,24.63-9.5,34.25,0,39.75,22-15.09,22-15.09Z",
    fill: "#9b59b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.89,144.57l-3.6-49.29s-14.19,4.88-18.44,24.63",
    fill: "#fff",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.08,40.22s-10.68-2.87-13-12.79c0,0,16.51-3.4,17,13.65Z",
    fill: "#9b59b6",
    opacity: 0.58
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.38,39.15s-7.5-11.74-1-22.78c0,0,12.6,7.92,7.08,22.78Z",
    fill: "#9b59b6",
    opacity: 0.73
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.3,39.15s3.89-12.45,15.78-14.86c0,0,2.26,8.07-7.65,14.86Z",
    fill: "#9b59b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "251.57 38.91 253.79 53.69 267.41 53.69 269.35 38.91 251.57 38.91",
    fill: "#24285b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186.94,
    y: 187.84,
    width: 8.2,
    height: 30.08,
    transform: "translate(-65.66 94.44) rotate(-23.82)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 67.58,
    width: 91.18,
    height: 44.49,
    fill: "#a5a5a5",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201.13,
    y: 134.8,
    width: 7.72,
    height: 30.08,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.6,99.28s12.77,0,16.77,26.39S201.13,203.36,168.1,243V164.87Z",
    fill: "#a5a5a5",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 120.38,
    width: 91.18,
    height: 44.49,
    fill: "#a5a5a5",
    opacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.06,85.57s36,0,40.29,20-18.75,79.75-18.75,79.75l-40.69-1.75s1.7-22.25-4.43-40.25S96.52,93.07,149.06,85.57Z",
    fill: "#9b59b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.1,108s-11.43,11.52-5.66,29.77-34,17.75-34,17.75,1.09,6.44,1.34,11.53c0,0,17.24,13,43.94,9.69l1.6-4.57,6.84-16.81Z",
    opacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.58,65.64S127,73,130.16,77.17a3.88,3.88,0,0,0,5.45.72c2.09-1.64,4.44-4.46,3.64-8.55l-.52-7.1a6.92,6.92,0,0,0-5.7-5.61C127.8,55.45,122.9,61.25,124.58,65.64Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.27 66.19 149.06 85.57 137.62 94.06 135.33 75.84 140.27 66.19",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.47,65.19a31.63,31.63,0,0,0,6.33-3.29,6.41,6.41,0,0,0,2.76,6.49,5.24,5.24,0,0,0,6.64-.55l-4-9.07a7.86,7.86,0,0,0-6.4-4.89,29.73,29.73,0,0,0-3.68-.19c-3.07.06-6.17,3.45-9.28,2.68a1.86,1.86,0,0,0-2.24,2.28c.77,3,3.12,7.1,7.52,7A7.35,7.35,0,0,0,126.47,65.19Z",
    fill: "#24285b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.71,68.51s-1.11-2.76,1-3.42,3.77,3.31,1.14,4.86Z",
    fill: "#f4a28c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.33,70.18l-.82,3.58A1.24,1.24,0,0,0,127,75.24l2.93-.64Z",
    fill: "#f4a28c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.61,77.89s2.62-3.6,2.63-5.91c0,0,3.52,6.72-1.82,12.55Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.93 111.58 102.93 147.58 125.48 156.24 145.93 140.91 142.2 102.91 119.93 119.91 93.93 111.58",
    fill: "#ffd200"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.93 119.91 99.27 104.24 101.05 113.86 119.93 119.91",
    fill: "#ffd200"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.93 119.91 99.27 104.24 101.05 113.86 119.93 119.91",
    fill: "#fff",
    opacity: 0.37
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.21,123.35S137,140.77,123.7,144.57s-22-2-22-2l1.25,5,22.55,8.66,20.45-15.33Z",
    opacity: 0.08
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4,101.82a10.29,10.29,0,0,1,17.21,2.8c4.86,11.45,10.44,31.77,2.11,53.82-12.75,33.75-63-3.5-63-3.5l7.55-8.25s26.47,12.5,37,6C181,147.25,158.35,117,171.4,101.82Z",
    fill: "#9b59b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4,101.82a10.29,10.29,0,0,1,17.21,2.8c4.86,11.45,10.44,31.77,2.11,53.82-12.75,33.75-63-3.5-63-3.5l7.55-8.25s26.47,12.5,37,6C181,147.25,158.35,117,171.4,101.82Z",
    fill: "#fff",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.73,153.8s-8.8-1.72-9.47-8.72,9.67,3.33,11.5,0,5.31-3.45,4.49,1.61Z",
    fill: "#f4a28c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.75,118.26s2.94-11.52,7.73-12.52c2.87-.6,2.44,1.5,1.64,3.28a9.71,9.71,0,0,0-.82,5.28l.09.68-6.46,4.93Z",
    fill: "#f4a28c"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.93 119.91 135.85 95.28 137.67 106.37 119.93 119.91",
    fill: "#ffd200"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.93 119.91 135.85 95.28 137.67 106.37 119.93 119.91",
    fill: "#fff",
    opacity: 0.37
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.77,232.73s3.09,2.79,2,6.18,1.79,5.56,3.83,3S168,230.12,168,230.12l-4.81-1.73Z",
    fill: "#9b59b6"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.45 122.13 127.3 129.58 139.38 121.5 138.34 113.53 126.45 122.13",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.61,249.07l-6.87-1.86,19.46-54.46-7.78-9,36.18,1.56a23.25,23.25,0,0,1-8.72,16.9,52.57,52.57,0,0,0-9.06,9A211.64,211.64,0,0,0,129.61,249.07Z",
    fill: "#24285b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 261.54,
    y: 82.22,
    width: 8.2,
    height: 30.08,
    transform: "translate(20.81 -44.45) rotate(9.95)",
    fill: "#a5a5a5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.17,
    y: 82.25,
    width: 7.77,
    height: 30.08,
    transform: "translate(20.07 -35.88) rotate(9.95)",
    fill: "#a5a5a5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 221.56,
    y: 81.76,
    width: 7.87,
    height: 30.08,
    transform: "translate(20.12 -37.52) rotate(9.95)",
    fill: "#a5a5a5",
    opacity: 0.44
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 134.31,
    width: 7.77,
    height: 30.08,
    transform: "translate(29.09 -35.34) rotate(9.95)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 221.56,
    y: 134.47,
    width: 7.87,
    height: 30.08,
    transform: "translate(29.23 -36.72) rotate(9.95)",
    fill: "#a5a5a5",
    opacity: 0.44
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 203.07,
    y: 81.76,
    width: 7.87,
    height: 30.08,
    transform: "translate(19.85 -34.32) rotate(9.95)",
    fill: "#a5a5a5",
    opacity: 0.44
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 232.04,
    y: 82,
    width: 8.79,
    height: 30.08,
    fill: "#a5a5a5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 242.06,
    y: 82,
    width: 7.72,
    height: 30.08,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 173.91,
    width: 91.18,
    height: 44.49,
    fill: "#a5a5a5",
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 261.54,
    y: 187.84,
    width: 8.2,
    height: 30.08,
    transform: "translate(39.06 -42.86) rotate(9.95)",
    fill: "#a5a5a5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 240.91,
    y: 188.32,
    width: 8.79,
    height: 30.08,
    fill: "#a5a5a5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 250.94,
    y: 188.32,
    width: 7.72,
    height: 30.08,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 261.23,
    y: 134.31,
    width: 8.2,
    height: 30.08,
    transform: "translate(29.81 -43.61) rotate(9.95)",
    fill: "#a5a5a5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 231.85,
    y: 134.8,
    width: 8.79,
    height: 30.08,
    fill: "#a5a5a5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 241.88,
    y: 134.8,
    width: 7.72,
    height: 30.08,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 228.73,
    width: 91.18,
    height: 19.07,
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226.69,
    cy: 237.13,
    r: 3,
    fill: "#a5a5a5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 222.55,
    y: 187.76,
    width: 7.77,
    height: 30.08,
    transform: "translate(38.46 -36.08) rotate(9.95)",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 230.5,
    y: 187.92,
    width: 7.87,
    height: 30.08,
    transform: "translate(38.61 -37.46) rotate(9.95)",
    fill: "#a5a5a5",
    opacity: 0.44
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 206.89,
    y: 187.76,
    width: 7.77,
    height: 30.08,
    transform: "translate(38.22 -33.38) rotate(9.95)",
    fill: "#a5a5a5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 214.84,
    y: 187.92,
    width: 7.87,
    height: 30.08,
    transform: "translate(38.37 -34.76) rotate(9.95)",
    fill: "#a5a5a5",
    opacity: 0.44
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.91,183.58l-1.09,26.54A12.59,12.59,0,0,0,136,222l25.38,12.15,2.49-6.13-14.76-10.72a11.11,11.11,0,0,1-4-12.49l6.75-20.27Z",
    fill: "#24285b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookLover);
export default __webpack_public_path__ + "static/media/book-lover.3e9a6c233b100c0b82e64614279de3c2.svg";
export { ForwardRef as ReactComponent };